/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React from "react";
import { useTranslation } from "react-i18next";

// @types
import { ServiceRequest } from "../../../../types/request.types";

interface RequestDetailsProfessionalProps {
  selectedRequest: ServiceRequest | null;
  image: Blob | null;
}

export const RequestDetailsProfessional: React.FC<RequestDetailsProfessionalProps> = ({ selectedRequest, image }) => {
  const { t } = useTranslation();

  if (!selectedRequest) {
    return (
      <div className="w-full p-4 bg-cBackground dark:bg-dark-cBackground xl:h-[75vh] rounded-lg shadow-lg text-cTextSecondary dark:text-dark-cText/60 flex items-center justify-center">
        {t("professional.request.selectRequest")}
      </div>
    );
  }

  return (
    <div className="w-full p-6 border dark:border-none rounded-lg bg-cBackground dark:bg-dark-cBackground shadow-md xl:h-[75vh] overflow-hidden xl:overflow-auto">
      {/* Título y ID */}
      <h3 className="text-lg font-semibold text-cText mb-2 dark:text-dark-cText">
        {t("professional.request.requestTitle")} {selectedRequest.serviceRequestNumber}
      </h3>
      <p className="text-sm text-cTextSecondary dark:text-dark-cText/60 mb-4">
        {selectedRequest.services[0]?.name || t("professional.request.notSpecificRequest")}
      </p>

      {/* Nombre del cliente */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-cTextSecondary dark:text-dark-cText/70">
          {t("professional.request.requestService")}
        </label>
        <p className="border rounded-md p-2 bg-cBackgroundSecondary dark:bg-dark-cBackground dark:border-gray-700 text-cText dark:text-dark-cText/60">
          {selectedRequest.customer.names} {selectedRequest.customer.lastNames}
        </p>
      </div>

      {/* Fecha y hora del servicio */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-cTextSecondary dark:text-dark-cText/70">
            {t("professional.request.serviceDate")}
          </label>
          <p className="border rounded-md p-2 bg-cBackgroundSecondary dark:bg-dark-cBackground dark:border-gray-700 text-cText dark:text-dark-cText/60">
            {new Date(selectedRequest.createdAt).toLocaleDateString()}
          </p>
        </div>
        <div>
          <label className="block text-sm font-medium text-cTextSecondary dark:text-dark-cText/70">
            {t("professional.request.serviceHour")}
          </label>
          <p className="border rounded-md p-2 bg-cBackgroundSecondary dark:bg-dark-cBackground dark:border-gray-700 text-cText dark:text-dark-cText/60">
            {new Date(selectedRequest.createdAt).toLocaleTimeString()}

          </p>
        </div>
      </div>

      {/* Imágenes o texto relacionado */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-cTextSecondary dark:text-dark-cText/70">
          {t("professional.request.image")}
        </label>
        {image && selectedRequest?.images.length ? (
          <img
            src={URL.createObjectURL(image)}
            alt="Imagen relacionada con el servicio"
            className="w-full h-[200px] object-cover rounded-md border dark:border-gray-700"
          />
        ) : (
          <div className="border rounded-md p-4 bg-cBackgroundSecondary dark:bg-dark-cBackground dark:border-gray-700 flex justify-center items-center text-cTextSecondary dark:text-dark-cText/70">
            {t("professional.request.noImage")}
          </div>
        )}
      </div>

      {/* Descripción del servicio */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-cTextSecondary dark:text-dark-cText/70">
          {t("professional.request.serviceDescription")}
        </label>
        <p className="border rounded-md p-2 bg-cBackgroundSecondary dark:bg-dark-cBackground dark:border-gray-700 text-cText dark:text-dark-cText/60">
          {selectedRequest.description || t("professional.request.noDescription")}
        </p>
      </div>
    </div>
  );
};
